import { memo } from "react";
import TablePagination from "./TablePagination";
import useTableFiltersHook from "./useTableFiltersHook";

interface TableFooterProps {
  nextDisabled?: boolean;
  tableName?: string;
}

const TableFooter = ({ nextDisabled, tableName }: TableFooterProps) => {
  const { filter, addpageNumber, addpageSize } = useTableFiltersHook(tableName);

  return (
    <div className="flex w-full justify-between py-16">
      <div data-tour="table.pagination">
        <TablePagination
          value={filter.pageNumber}
          nextDisabled={nextDisabled}
          onNextClick={() => addpageNumber(tableName, filter.pageNumber + 1)}
          onPrevClick={() => addpageNumber(tableName, filter.pageNumber - 1)}
        />
      </div>
      <select
        data-tour="table.page-size"
        className="bg-white text-black border border-black rounded-md p-2 outline-none"
        value={filter.pageSize}
        onChange={(e) => addpageSize(tableName, parseInt(e.target.value))}
      >
        <option value={10}>10</option>
        <option value={25}>25</option>
        <option value={50}>50</option>
        <option value={100}>100</option>
      </select>
    </div>
  );
};

export default memo(TableFooter);
